import { render, staticRenderFns } from "./LikeComment.vue?vue&type=template&id=6ab7324a&scoped=true"
import script from "./LikeComment.vue?vue&type=script&lang=js"
export * from "./LikeComment.vue?vue&type=script&lang=js"
import style0 from "./LikeComment.vue?vue&type=style&index=0&id=6ab7324a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7324a",
  null
  
)

export default component.exports